"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _locales = _interopRequireDefault(require("./locales"));
var _config = require("./config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Provider = function Provider(props) {
  var children = props.children,
    _props$defaultLocale = props.defaultLocale,
    defaultLocale = _props$defaultLocale === void 0 ? _config.FALLBACK_LOCALE : _props$defaultLocale;
  var _props$locale = props.locale,
    locale = _props$locale === void 0 ? _config.FALLBACK_LOCALE : _props$locale;

  /**
   * Check if locale is among supported locales,
   * else locale should fallback to FALLBACK_LOCALE
   */
  if (!(locale in _locales.default)) {
    locale = _config.FALLBACK_LOCALE;
  }
  return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    locale: locale,
    messages: _locales.default[locale],
    defaultLocale: defaultLocale
  }, children);
};
Provider.propTypes = {
  children: _propTypes.default.node.isRequired,
  locale: _propTypes.default.string,
  defaultLocale: _propTypes.default.string
};
var _default = Provider;
exports.default = _default;